
























































































































































































































































































import BaseComponent from '@/components/base-component.vue';
import CrmDashboardFilters from '@/components/crm/dashboard/dashboard-filters.vue';
import VisitsDataTableCharts from '@/components/crm/dashboard/data-table-chart.vue';
import PlanningModalityCharts from '@/components/crm/dashboard/planning-modality-chart.vue';
import VisitsInstitutionsCharts from '@/components/crm/dashboard/visits-institutions-chart.vue';
import VisitsVisitorsCharts from '@/components/crm/dashboard/visits-visitors-chart.vue';
import VisitsVisitorsContactsAvgCharts from '@/components/crm/dashboard/visits-visitors-contacts-avg.vue';
import VisitsVisitorsDailyCharts from '@/components/crm/dashboard/visits-visitors-daily-chart.vue';
import VisitsVisitorsDailyAvgCharts from '@/components/crm/dashboard/visits-visitors-daily-avg-chart.vue';
import VisitsVisitorsTimeCharts from '@/components/crm/dashboard/visits-visitors-time-chart.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { DashboardFiltrosDTO } from '@/interfaces/crm-dashboard';
import * as service from '@/services/crm-dashboard';
import { BehaviorSubject } from 'rxjs';
import Component from 'vue-class-component';
import VisitsVsAdmCharts from '@/components/crm/dashboard/visits-vs-adm-chart.vue';
import AdmsVisitorsCharts from '@/components/crm/dashboard/adms-visitors-chart.vue';
import AdmsVisitorsDailyCharts from '@/components/crm/dashboard/adms-visitors-daily-chart.vue';

@Component({
  components: {
    UiDatePicker,
    UiFilterContainer,
    CrmDashboardFilters,
    VisitsVisitorsCharts,
    PlanningModalityCharts,
    ListMessages,
    VisitsVisitorsDailyCharts,
    VisitsVisitorsDailyAvgCharts,
    VisitsVisitorsTimeCharts,
    VisitsDataTableCharts,
    VisitsInstitutionsCharts,
    VisitsVisitorsContactsAvgCharts,
    VisitsVsAdmCharts,
    AdmsVisitorsCharts,
    AdmsVisitorsDailyCharts
  }
})
export default class Dashboard extends BaseComponent {
  public $refs!: {
    form: HTMLFormElement;
  };

  filters = {};
  currentTab = 0;
  configs = null;
  loadingKpis = false;
  kpis = {};
  admKpis = {};
  loadingKpisVisitors = false;
  kpisVisitors = [];
  loadingkpisVisitorsDaily = false;
  kpisVisitorsDaily = [];
  loadingkpisVisitorsDailyAvg = false;
  kpisVisitorsDailyAvg = [];
  loadingKpisInstitutions = false;
  kpisInstitutions = [];
  loadingAdmKpisVisitors = false;
  admKpisVisitors = [];
  loadingAdmKpisDailyVisitors = false;
  admKpisDailyVisitors = [];
  tpAtvInt = 'TT';

  onFilter(f) {
    this.loadKPIs(f);
  }

  private bsKpis$: BehaviorSubject<any> = new BehaviorSubject(null);
  private bsKpisVisitors$: BehaviorSubject<any> = new BehaviorSubject(null);
  private bsAdmKpisVisitors$: BehaviorSubject<any> = new BehaviorSubject(null);
  private bsAdmKpisDailyVisitors$: BehaviorSubject<any> = new BehaviorSubject(null);
  private bsKpisVisitorsDaily$: BehaviorSubject<any> = new BehaviorSubject(null);
  private bsKpisVisitorsDailyAvg$: BehaviorSubject<any> = new BehaviorSubject(null);
  private bsKpisInstitutions$: BehaviorSubject<any> = new BehaviorSubject(null);

  beforeMount() {
    this.buildBsKpis();
    this.buildBsKpisVisitors();
    this.buildBsAdmKpisVisitors();
    this.buildBsAdmKpisDailyVisitors();
    this.buildBsKpisVisitorsDaily();
    this.buildBsKpisVisitorsDailyAvg();
    this.buildBsKpisInstitutions();

    this.loadConfigs();
  }

  buildBsKpis() {
    this.bsKpis$ = this.buildBehaviorSubject(
      (f) => service.listCrmDashboardKPIs(f),
      () => (this.loadingKpis = true),
      300,
      (res) => {
        this.loadingKpis = false;
        this.kpis = res.visita;
        this.admKpis = res.agendaInterna;
      },
      (error) => {
        this.kpis = {};
        this.loadingKpis = false;
        this.showToastApiError(error);
        this.buildBsKpis();
      }
    );
  }

  buildBsKpisVisitors() {
    this.bsKpisVisitors$ = this.buildBehaviorSubject(
      (f) => service.listCrmDashboardKPIsVisitors(f),
      () => (this.loadingKpisVisitors = true),
      300,
      (res) => {
        this.loadingKpisVisitors = false;
        this.kpisVisitors = res;
      },
      (error) => {
        this.kpisVisitors = [];
        this.loadingKpisVisitors = false;
        this.showToastApiError(error);
        this.buildBsKpisVisitors();
      }
    );
  }

  buildBsAdmKpisVisitors() {
    this.bsAdmKpisVisitors$ = this.buildBehaviorSubject(
      (f) => service.listCrmDashboardAdmKPIsVisitors(f),
      () => (this.loadingAdmKpisVisitors = true),
      300,
      (res) => {
        this.loadingAdmKpisVisitors = false;
        this.admKpisVisitors = res;
      },
      (error) => {
        this.admKpisVisitors = [];
        this.loadingAdmKpisVisitors = false;
        this.showToastApiError(error);
        this.buildBsAdmKpisVisitors();
      }
    );
  }

  buildBsAdmKpisDailyVisitors() {
    this.bsAdmKpisDailyVisitors$ = this.buildBehaviorSubject(
      (f) => service.listCrmDashboardAdmKPIsVisitorsDaily(f),
      () => (this.loadingAdmKpisDailyVisitors = true),
      300,
      (res) => {
        this.loadingAdmKpisDailyVisitors = false;
        this.admKpisDailyVisitors = res;
      },
      (error) => {
        this.admKpisDailyVisitors = [];
        this.loadingAdmKpisDailyVisitors = false;
        this.showToastApiError(error);
        this.buildBsAdmKpisDailyVisitors();
      }
    );
  }

  buildBsKpisVisitorsDaily() {
    this.bsKpisVisitorsDaily$ = this.buildBehaviorSubject(
      (f) => service.listCrmDashboardKPIsVisitorsDaily(f),
      () => (this.loadingkpisVisitorsDaily = true),
      300,
      (res) => {
        this.loadingkpisVisitorsDaily = false;
        this.kpisVisitorsDaily = res;
      },
      (error) => {
        this.kpisVisitorsDaily = [];
        this.loadingkpisVisitorsDaily = false;
        this.showToastApiError(error);
        this.buildBsKpisVisitorsDaily();
      }
    );
  }

  buildBsKpisVisitorsDailyAvg() {
    this.bsKpisVisitorsDailyAvg$ = this.buildBehaviorSubject(
      (f) => service.listCrmDashboardKPIsVisitorsDailyAvg(f),
      () => (this.loadingkpisVisitorsDailyAvg = true),
      300,
      (res) => {
        this.loadingkpisVisitorsDailyAvg = false;
        this.kpisVisitorsDailyAvg = res;
      },
      (error) => {
        this.kpisVisitorsDailyAvg = [];
        this.loadingkpisVisitorsDailyAvg = false;
        this.showToastApiError(error);
        this.buildBsKpisVisitorsDailyAvg();
      }
    );
  }

  buildBsKpisInstitutions() {
    this.bsKpisInstitutions$ = this.buildBehaviorSubject(
      (f) => service.listCrmDashboardKpisInstitutions(f),
      () => (this.loadingKpisInstitutions = true),
      300,
      (res) => {
        this.loadingKpisInstitutions = false;
        this.kpisInstitutions = res;
      },
      (error) => {
        this.kpisInstitutions = [];
        this.loadingKpisInstitutions = false;
        this.showToastApiError(error);
        this.buildBsKpisInstitutions();
      }
    );
  }

  loadConfigs() {
    service.listCrmDashboardConfigs().subscribe(
      (res) => {
        this.configs = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  loadKPIs(filters) {
    let f = new DashboardFiltrosDTO();
    f.dataIni = !!filters.datas && filters.datas.length == 2 ? filters.datas[0] : null;
    f.dataFim = !!filters.datas && filters.datas.length == 2 ? filters.datas[1] : null;
    f.cdsAreas = filters.cdsAreas;
    f.idsVisitantes = filters.idsVisitantes;

    this.filters = f;

    this.tpAtvInt = 'TT';

    this.bsKpis$.next(f);
    this.bsKpisVisitors$.next(f);
    this.bsAdmKpisVisitors$.next(f);
    this.bsAdmKpisDailyVisitors$.next(f);
    this.bsKpisVisitorsDaily$.next(f);
    this.bsKpisVisitorsDailyAvg$.next(f);
    this.bsKpisInstitutions$.next(f);
  }

  keyValue = 0;
  onChangeTab() {
    this.keyValue++;
  }
}
